<template>
  <div class="bottom">
    Copyright 2019 长春市把手科技有限公司&emsp;&emsp;<span @click="showModal"
      >用户协议</span
    >&emsp;&emsp;联系方式：0431-81884046
    <a-modal
      class="modal"
      title="用户协议"
      v-model="visible"
      @ok="handleOk"
      okText="确定"
      cancelText="取消"
      width="700px"
    >
      <div class="title-item">用户协议</div>
      <div class="cont">
        <p>
          感谢您使用把手科技的产品和服务。本协议是用户（包括注册用户及未注册的访客）以注册、访问或浏览方式使用把手科技的产品与服务时与把手科技有限公司签署的协议。为更好地使用把手科技的产品与服务，您需阅读、理解本协议的所有条款，包括“服务条款”、“隐私条款”、“免责声明”和“版权声明”，并同意受其约束。若您不同意本协议，请勿使用把手科技的产品与服务。
        </p>
      </div>
      <div class="title-item-item">服务条款</div>
      <div class="cont">
        <p>
          1．您在接受本协议之后，设置的帐号、密码是您用以登录把手科技产品，接受把手科技服务持有的身份识别凭证。
        </p>
        <p>
          2．您对录入、上传、提交及发表的内容和信息拥有所有权，您的上述行为视为同意授予把手科技无须取得您和他人同意、无需另行通知或补偿您或他人即可使用、复制、修改、传播、发表、加工您通过把手科技产品与服务提供的信息和内容的权利。
        </p>
        <p>
          3．因为您填写的信息将会对把手科技产品和服务的计算和分析结果带来一定影响，您需承诺提供信息和数据的真实性。
        </p>
        <p>
          4．如果把手科技认为您的账户或行为可能违反了本协议或法律，或对把手科技产品和服务使用不当，把手科技将保留限制、暂停或终止您帐户的权利。
        </p>
        <p>
          5．您不得利用把手科技的产品与服务发表、传播、储存危害国家安全、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容。
        </p>
        <p>
          6．您不得利用把手科技的产品与服务发表、传播、储存侵害他人财产所有权、知识产权、人身权利等合法权利的内容。
        </p>
        <p>
          7．未经授权，您不得收集、使用、复制、交易任何把手科技产品与服务上的内容、信息或数据。
        </p>
        <p>
          8．您不得利用把手科技的产品与服务进行其他任何违法以及侵犯其他个人、公司、社会团体、组织的合法权益的行为。
        </p>
      </div>
      <div class="title-item">隐私条款</div>
      <div class="cont">
        <p>
          我们致力于保护您在使用把手科技的产品和服务时提供的个人信息，包括注册账户信息以及把手科技收集的用户自检记录等信息。您所提交的某些信息可能是个人身份验证信息
          （即可辨明您个人身份的信息，例如您的姓名、职业、电话号码等），我们基于以下情形可能使用您的个人信息：
        </p>
        <p>
          （1）保证您正常使用“{{
            $store.state.clientele.displayName
          }}”产品及服务；
        </p>
        <p>
          （2）向您发送关于“{{
            $store.state.clientele.displayName
          }}”产品及服务的相关信息；
        </p>
        <p>（3）为您定制个性化产品需求和功能；</p>
        <p>（4）把手科技进行客户需求分析的需要；</p>
        <p>（5）把手科技进行产品功能维护或升级的需要；</p>
        <p>（6）其他为了提升把手科技的产品与服务质量的内部使用。</p>
        <p>
          在以下情形，“{{
            $store.state.clientele.displayName
          }}”可能根据国家相关规定披露您的信息：
        </p>
        <p>
          （1）您的行为违反了互联网相关法律法规的规定，或可能损害或妨碍其他用户的权益时，披露您的个人信息是为了辨识、联络或采取法律行动所必需时；
        </p>
        <p>（2）按法律规定或涉及司法或政府的调查而披露；</p>
        <p>（3）法律法规所规定的其他必须披露个人信息的情形。</p>
      </div>
      <div class="title-item">免责声明</div>
      <div class="cont">
        <p>
          本{{
            $store.state.clientele.displayName
          }}中的自检报告结果均依据您进行自检问卷作答的内容自动生成，最终形成的报告中的企业风险评级以及相应的风险防范意见均取决于您填写的问卷内容。
        </p>
        <p>
          您在使用把手科技的产品与服务时必须遵守国家有关法律和政策，并遵守本条款，对于用户违法或违反本协议的使用而引起的一切后果，把手科技不承担任何责任。
        </p>
        <p>
          因本网站的的技术故障等不可预测事件影响到服务的正常运行，我们承诺尽快进行修复，但由于不可抗力、意外事件（包括但不限于计算机病毒感染、黑客攻击）导致用户信息被破坏、泄密并造成损失的，把手科技不承担任何法律责任。
        </p>
      </div>
      <div class="title-item">版权声明</div>
      <div class="cont">
        <p>
          任何域名中包含“bashou.tech,lawsdata.com”的网站均属把手科技有限公司所有，并由把手科技有限公司负责运营。
        </p>
        <p>
          本网站及其他由把手运营的法律类服务产品所有内容的版权归“把手”所有，受中华人民共和国版权法和中国缔结的版权公约、著作权公约的保护。
        </p>
        <p>
          您不得以任何方式复制、翻印、再版、上传、转贴、传播或散发本网站以及其中任何的内容，包括但不限于设计、标志、配色方案、图形样式、文本、图片和视频等版权作品。
        </p>
        <p>
          禁止提取本网站全部或大部分版权作品的行为，对版权作品进行修改或将其用于任何其他用途，均构成对版权所有人权利的侵犯，被严格禁止。
        </p>
        <p>
          把手科技尊重并严格遵守版权法。同样地，“把手科技”也希望使用“本网站”的所有客户尊重并严格遵守版权法，共同营造良好的使用环境。
        </p>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" type="text/less" scoped>
.bottom {
  width: 100%;
  height: 40px;
  line-height: 40px;
  .modal {
    .title-item {
      font-size: 14px;
      font-weight: 700 !important;
      color: #444;
    }
    .cont {
      font-size: 12px;
      color: #999;
      p {
        text-indent: 16px;
      }
    }
  }
  span {
    cursor: pointer;
    color: #5867dd;
    text-decoration: underline;
  }
}
/deep/.ant-modal-body {
  max-height: 600px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: #e7e7e7;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: @primary-color;
  }
}
</style>
